import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import { BrandMark } from "../components/Brand";
import { toast } from "sonner";

const tl = (n) => (Number(n) || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " TL";

export default function FaturaOnizleme() {
  const { token } = useParams();
  const [d, setD] = useState(null); const [err, setErr] = useState("");
  const load = useCallback(() => api.get(`/public/invoice/${token}`, { silent: true }).then((r) => setD(r.data)).catch(() => setErr("ÖNİZLEME BULUNAMADI")), [token]);
  useEffect(() => { load(); }, [load]);
  const approve = async () => { await api.post(`/public/invoice/${token}/approve`, { data: {} }); toast.success("ONAYINIZ ALINDI, TEŞEKKÜRLER"); load(); };
  if (err) return <div className="py-20 text-center text-slate-500">{err}</div>;
  if (!d) return null;
  const x = d.data;
  return (
    <div data-testid="invoice-preview-page" className="min-h-screen bg-slate-100 p-4 text-slate-900">
      <div className="mx-auto max-w-xl rounded-xl bg-white p-5 shadow">
        <div className="mb-3 flex items-center gap-3 border-b pb-3">{d.brand?.name && <BrandMark brand={d.brand} size={40} />}<div><div className="text-lg font-bold">{d.brand?.name}</div><div className="text-xs text-slate-500">FATURA ÖNİZLEME (RESMİ FATURA DEĞİLDİR)</div></div></div>
        <div className="grid grid-cols-2 gap-1 text-xs">
          <span className="text-slate-500">TAKİP NO</span><b>{x.takip_no}</b><span className="text-slate-500">TARİH</span><b>{x.tarih}</b>
          <span className="text-slate-500">GÖNDEREN</span><b>{x.gonderen_firma}</b><span className="text-slate-500">ALICI</span><b>{x.alici_firma}</b>
          <span className="text-slate-500">VARIŞ</span><b>{x.alici_ilce} / {x.alici_il}</b><span className="text-slate-500">ADET / KG / DESİ</span><b>{x.adet} / {x.kg} / {x.desi}</b>
          <span className="text-slate-500">ÖDEME</span><b>{x.odeme}</b>
        </div>
        <table className="mt-3 w-full text-xs"><tbody>
          {d.lines.map((l, i) => <tr key={i} className="border-b"><td className="py-1">{l.ad}</td><td className="py-1 text-right">{tl(l.tutar)}</td></tr>)}
          <tr><td className="py-1 text-slate-500">YEKÜN</td><td className="text-right">{tl(d.yekun)}</td></tr>
          <tr><td className="py-1 text-slate-500">SİGORTA</td><td className="text-right">{tl(d.sigorta)}</td></tr>
          <tr><td className="py-1 text-slate-500">KDV</td><td className="text-right">{tl(d.kdv)}</td></tr>
          <tr className="text-base font-bold"><td className="py-2">TOPLAM</td><td data-testid="inv-prev-total" className="text-right">{tl(d.toplam)}</td></tr>
        </tbody></table>
        {d.onay ? <div data-testid="inv-prev-approved" className="mt-3 rounded bg-emerald-100 p-2 text-center text-sm font-bold text-emerald-700">ONAYLADINIZ — TEŞEKKÜRLER</div>
          : <button data-testid="inv-prev-approve" onClick={approve} className="mt-3 h-11 w-full rounded-lg bg-emerald-600 font-bold text-white">BİLGİLER DOĞRU, ONAYLIYORUM</button>}
      </div>
    </div>
  );
}
